import { Component, OnInit } from '@angular/core';
import { EventService } from 'src/app/Service/event.service';

@Component({
    selector: 'app-home',
    templateUrl: 'home.component.html'
})

export class HomeComponent implements OnInit {

    message: string;

    constructor(
        protected eventService: EventService
    ) {
        this.message = 'Bienvenido';
    }

    ngOnInit() {
        //this.eventService.startLoadingData();
    }

}
